// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"344":"af6ea0236bdca5de","507":"e8aedfcdcf1a2f31"}[chunkId] + ".js";
};